import { ActionDispatching } from 'app/types-shared';
import { toastFactory } from 'app/infrastructure/notifications/toast-factory';
import { api } from './api';
import {
  RequestLoadDrafts, ReceiveLoadDrafts, FailLoadDrafts,
  RequestDeleteDraft, ReceiveDeleteDraft, FailDeleteDraft
} from './action-types';

export const actionCreators = {

  loadDrafts: (failMessage: string): ActionDispatching<any, any> =>
    async (dispatch: any) => {
      dispatch(new RequestLoadDrafts());
      try {
        const drafts = await api.getUserDrafts();
        dispatch(new ReceiveLoadDrafts(drafts || []));
      } catch {
        dispatch(new FailLoadDrafts());
        toastFactory().dispatchError(failMessage);
      }
    },

  deleteDraft: (draftId: number, failMessage: string): ActionDispatching<any, any> =>
    async (dispatch: any) => {
      dispatch(new RequestDeleteDraft());
      try {
        await api.deleteDraft(draftId);
        dispatch(new ReceiveDeleteDraft(draftId));
      } catch {
        dispatch(new FailDeleteDraft());
        toastFactory().dispatchError(failMessage);
      }
    }
};
